export default "__VITE_ASSET__f8031dc2__"